import { PaginatedResult } from '../types/PaginatedResult';
import { httpGet, httpPost, httpPut, httpDelete } from './api.service';
import { Facility } from '../types/Facility';
import { GetCommentRequest } from '../requestModels/getCommentRequest';

const getComments = async (request: GetCommentRequest): Promise<PaginatedResult<Facility>> => {
  const { resourceId, resourceType } = request;
  delete request.resourceId;
  delete request.resourceType;
  return await httpGet<PaginatedResult<Facility>>(`api/comment/resourceType/${resourceType}/subjectId/${resourceId}`, request);
};

const addComment = async (request: GetCommentRequest): Promise<boolean> => {
  return await httpPost(`api/comment`, request);
};

const updateComment = async (request: GetCommentRequest): Promise<boolean> => {
  return await httpPut(`api/comment`, request);
};

const deleteComment = async (id: string): Promise<boolean> => {
  return await httpDelete(`api/comment/${id}`);
};

export { getComments, addComment, updateComment, deleteComment };
